import React from "react";
import { Box, TableRow, TableCell, Typography } from "@material-ui/core";
import { isColorLight } from "../../../components/TagsAtentus/ChipTag";

export function Step({ title, time, color, umbral }) {
    return (
        <TableRow
            style={{
                backgroundColor:
                    color !== "#bdbdbd" && color !== "#41B900"
                        ? color
                        : "transparent",
                height: "2.2rem",
            }}
        >
            <TableCell
                style={{
                    borderStyle: "none",
                    borderBottom: `1px solid #d4d4d8`,
                    padding: "0 3px 0 3px",
                }}
            >
                <Box display="flex" alignItems="center">
                    <span
                        style={{
                            width: "0.5rem",
                            height: "1.25rem",
                            backgroundColor: color,
                            marginRight: "0.5rem",
                        }}
                    ></span>
                    <Typography
                        style={{
                            color: isColorLight(color) ? "#000000" : "#ffffff",
                        }}
                    >
                        {title}
                    </Typography>
                </Box>
            </TableCell>
            <TableCell
                style={{
                    textAlign: "right",
                    borderBottom: `1px solid #d4d4d8`,
                    padding: "0 3px 0 3px",
                    backgroundColor:
                        parseFloat(time) >= parseFloat(umbral)
                            ? "#da8e1d"
                            : "inherit",
                }}
            >
                <Typography
                    style={{
                        color:
                            isColorLight(color) &&
                            parseFloat(time) < parseFloat(umbral)
                                ? "#000000"
                                : "#ffffff",
                    }}
                >
                    {time} s
                </Typography>
            </TableCell>
            <TableCell
                style={{
                    textAlign: "right",
                    borderBottom: `1px solid #d4d4d8`,
                    padding: "0 3px 0 3px",
                }}
            >
                <Typography
                    style={{
                        color: isColorLight(color) ? "#000000" : "#ffffff",
                    }}
                >
                    {umbral} s
                </Typography>
            </TableCell>
        </TableRow>
    );
}
